import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useResetSourceFrames } from "@/api/media-transmitters/mutations";

export function useResetSourceFlow() {
	const { t } = useTranslation();
	const [pendingSn, setPendingSn] = useState<string | null>(null);
	const reset = useResetSourceFrames();

	return {
		pendingSn,
		open: (sn: string) => setPendingSn(sn),
		close: () => setPendingSn(null),
		isPending: reset.isPending,
		confirm: () => {
			if (pendingSn === null) return;
			reset.mutate(pendingSn, {
				onSuccess: () => {
					toast.success(t("mediaTransmitters.resetSuccess"));
					setPendingSn(null);
				},
				onError: () => {
					toast.error(t("mediaTransmitters.resetError"));
				},
			});
		},
	};
}
